/**
 * 车辆列表
 */
import { VEHICLEINSURANCELIST } from '../types';

export default {
    name: `${VEHICLEINSURANCELIST}`,
    path: '/vehicleInsuranceList',
    component: () => import('@/views/vehicleInsuranceList/'),
    redirect: { name: `${VEHICLEINSURANCELIST}Index` },
    meta: {
        title: '车险信息',
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: `${VEHICLEINSURANCELIST}Index`,
            path: 'index',
            component: () => import('@/views/vehicleInsuranceList/home/Home.vue'),
        },
        {
            name: `${VEHICLEINSURANCELIST}Detail`,
            path: 'read',
            component: () => import('@/views/vehicleInsuranceList/detail/Detail.vue'),
        },
    ],
};
